import { useSelector } from "react-redux";
import { useState } from "react";
import FilterMenu from "../FilterMenu/FilterMenu";
import ProductList from "../ProductList/ProductList";
import DesignMenu from "../DesignMenu/DesignMenu";
import toggleIcon from './assets/toggle.svg';
import styles from "./ProductMenu.module.css"

export default  function ProductMenu() {
        
    const appliedFilters = useSelector(state => state.visualizer.appliedFilters);
    const lastUsedFilter = useSelector(state => state.visualizer.lastAppliedFilter);
    const activePattern = useSelector(state => state.visualizer.activePattern);
    const selectedSlot = useSelector(state => state.visualizer.selectedSlot);

    const [menuMode, setMenuMode] = useState("");
    const [activeSubMenu, setActiveSubMenu] = useState("abstract");

    const handleSelect = () => {

    }

    const handleSubMenuClick = (category) => {
        setActiveSubMenu(category);
    }

    // Check if the currently selected slot is a stripping slot
    const isStrippingSlot = () => {
        if (!activePattern?.descriptor) return false;
        
        const slots = activePattern.descriptor.split(',').map(slot => slot.trim());
        const currentSlotLabel = slots[selectedSlot] || '';
        
        return currentSlotLabel.toLowerCase().includes('stripping');
    };

    const showSolidCategory = isStrippingSlot();
    
    return (
        <section className={menuMode}>
            {menuMode !== "fullMenu" && 

                <div className={styles.menuTop}>
                <DesignMenu/>
                </div>
            }

            <div className={styles.midMenu}>
                <ul className={styles.subMenu}>
                    <li className={activeSubMenu === 'abstract' ? styles.active : ''} onClick={() => handleSubMenuClick("abstract")}>abstract</li>
                    <li className={activeSubMenu === 'stone' ? styles.active : ''} onClick={() => handleSubMenuClick("stone")}>stone</li>
                    <li className={activeSubMenu === 'wood' ? styles.active : ''} onClick={() => handleSubMenuClick("wood")}>wood</li>
                    {showSolidCategory && (
                        <li className={activeSubMenu === 'solid' ? styles.active : ''} onClick={() => handleSubMenuClick("solid")}>solid</li>
                    )}
                </ul>
            </div>
            <div  className={styles.menuBottom}>
               
              <ProductList seriesId={9696} thumbSize={200} handleSelect={handleSelect} selectedProductId={-1} categoryFilter={activeSubMenu} />
                 
            </div>
        </section>
    );
}
